// extracted by mini-css-extract-plugin
export default {"main_body_stats":"ProfileStats_main_body_stats__wRQx2","main_body_stats_card":"ProfileStats_main_body_stats_card__vAlQn"};